import React, { Fragment, useState, useEffect } from 'react'
import callApi from '../../helpers/callapi'
import { Form, Card, Button, Row, Col, Table, Modal, Badge } from 'react-bootstrap'

const LuckyNumber = () => {
  const [luckyNumber, setLuckyNumber] = useState([])
  const [showRemoveModal, setShowRemoveModal] = useState(false)
  const [showEditModal, setShowEditModal] = useState(false)
  const [selected, setSelected] = useState([])
  const [addData, setAddData] = useState([])
  const [title, setTitle] = useState('')
  const [label, setLabel] = useState('')
  const [amount, setAmount] = useState('')
  const [perClick, setPerClick] = useState('')
  const [userId, setUserId] = useState('')
  const [arrUserId, setArrUserId] = useState([])
  const [roundDate, setRoundDate] = useState()
  const [selectLabel, setSelectLabel] = useState('Select...')
  const [files, setFiles] = useState([])

  const fetchLuckyNumber = async () => {
    try {
      const _luckyNumber = await callApi({
        url: `/contents/lucky-number`,
      })
      setLuckyNumber(_luckyNumber.value)
    } catch (error) {
      setLuckyNumber(null)
    }
  }
  const sendData = async () => {
    try {
      await callApi({
        url: `/contents/lucky-number`,
        method: 'post',
        body: { value: luckyNumber },
      })
      alert('ส่งข้อมูลเรียบร้อย')
    } catch (error) {
      alert('เกิดข้อผิดพลาด')
    }
  }
  const sendUserId = async () => {
    try {
      await callApi({
        url: `/luckyNumber`,
        method: 'post',
        body: { id: selectLabel !== 'Select...' ? `${roundDate}-${selectLabel}` : '', value: arrUserId.concat(files) },
      })
      alert('ส่งข้อมูลเรียบร้อย')
    } catch (error) {
      alert('เกิดข้อผิดพลาด')
    }
  }
  const fetchRoundDate = async () => {
    try {
      const _roundDate = await callApi({
        url: `/contents/round-date`,
      })
      setRoundDate(_roundDate.value)
    } catch (error) {
      // dispatch({type:"loading_hide"});
    }
  }

  useEffect(() => {
    fetchLuckyNumber()
    fetchRoundDate()
  }, [])

  const addLuckyNumber = () => {
    setLuckyNumber([...luckyNumber, { title, label, amount: parseInt(amount), perClick: parseInt(perClick) }])
    document.querySelectorAll('.form-control').forEach((el) => (el.value = ''))
    setTitle('')
    setLabel('')
    setAmount('')
    setPerClick('')
  }

  const confirmRemove = () => {
    const temp = luckyNumber.filter((data) => data.title !== title)
    // console.log('title',title)
    setLuckyNumber(temp)
    setShowRemoveModal(false)
  }

  const updateLuckyNumber = () => {
    const temp = luckyNumber[addData]
    const index = luckyNumber.findIndex((el) => el.title === temp.title)
    luckyNumber[index] = {
      title,
      label,
      amount: parseInt(amount),
      perClick: parseInt(perClick),
    }
    setShowEditModal(false)
  }

  const addUserId = () => {
    if (!userId || /^\s/.test(userId)) {
      return
    }
    setArrUserId([...arrUserId, userId])
    setUserId('')
    document.querySelector('#userId').value = ''
  }

  const removeUserId = (value) => {
    const remove = arrUserId.filter((data) => data !== value)
    setArrUserId(remove)
    // console.log('userId',userId)
    // console.log('value',value)
  }
  const readFileContent = (file) => {
    const fileReader = new FileReader()
    return new Promise((res, rej) => {
      fileReader.onload = (e) => res(e.target.result)
      fileReader.onerror = (err) => rej(err)
      fileReader.readAsText(file)
    })
  }
  const handleChange = (e) => {
    const input = e.target
    if ('files' in input && input.files.length > 0) {
      for (const file of input.files) {
        readFileContent(file)
          .then(async (content) => {
            try {
              setFiles(JSON.parse(content))
              //console.log('content',JSON.parse(content))
            } catch (err) {
              console.log('error')
            } finally {
              console.log('finally')
            }
          })
          .catch((err) => {
            console.log(err)
          })
      }
    }
  }
  // console.log("arr",arrUserId.concat(files))
  // console.log({id: selectLabel !== "Select..." ? `${roundDate}-${selectLabel}` : "", value: arrUserId.concat(files)})

  return (
    <Fragment>
      <Card>
        <Card.Header>
          <Card.Title>Lucky Number</Card.Title>
        </Card.Header>
        <Card.Body>
          <div className="d-flex mt-2 mb-4">
            <input
              // className="form-control"
              style={{ color: '#5d5d5d' }}
              type="text"
              placeholder="title"
              className="form-control mr-2"
              onChange={(e) => setTitle(e.target.value)}
            />
            <input
              // className="form-control"
              style={{ color: '#5d5d5d' }}
              type="text"
              placeholder="label"
              className="form-control mr-2"
              onChange={(e) => setLabel(e.target.value)}
            />
            <input
              // className="form-control"
              style={{ color: '#5d5d5d' }}
              type="number"
              placeholder="amount"
              className="form-control mr-2"
              onChange={(e) => setAmount(e.target.value)}
            />
            <input
              // className="form-control"
              style={{ color: '#5d5d5d' }}
              type="number"
              placeholder="perClick"
              className="form-control mr-2"
              onChange={(e) => setPerClick(e.target.value)}
            />
            {title === '' ||
            label === '' ||
            amount === '' ||
            perClick === '' ||
            parseInt(perClick) > parseInt(amount) ? (
              <Button disabled={true} variant="dark">
                ยืนยัน
              </Button>
            ) : (
              <div className="btn btn-primary light" style={{ minWidth: '120px' }} onClick={() => addLuckyNumber()}>
                ยืนยัน
              </div>
            )}
          </div>
          <Table responsive striped bordered>
            <thead>
              <tr>
                <th>title</th>
                <th style={{ width: '25%' }}>label</th>
                <th>amount</th>
                <th>perClick</th>
                <th style={{ width: '25%' }}></th>
              </tr>
            </thead>
            <tbody>
              {luckyNumber &&
                luckyNumber.map((data, i) => {
                  return (
                    <tr key={i}>
                      <td>{data.title}</td>
                      <td>{data.label}</td>
                      <td>{data.amount}</td>
                      <td>{data.perClick}</td>
                      <td>
                        <Button
                          variant="primary light"
                          onClick={() => {
                            setShowEditModal(true)
                            setAddData(i)
                            setSelected(data)
                            setTitle(data.title)
                            setLabel(data.label)
                            setAmount(data.amount)
                            setPerClick(data.perClick)
                          }}
                        >
                          {' '}
                          <i className="fa fa-pencil"></i> แก้ไข
                        </Button>{' '}
                        <Button
                          variant="danger light"
                          onClick={() => {
                            setShowRemoveModal(true)
                            setTitle(data.title)
                          }}
                        >
                          <i className="fa fa-trash"></i> ยกเลิก
                        </Button>
                      </td>
                    </tr>
                  )
                })}
            </tbody>
          </Table>
          <div style={{ textAlign: 'center' }}>
            <Button onClick={() => sendData()}>ส่งข้อมูล</Button>
          </div>
        </Card.Body>
        <Card.Body>
          <Row>
            <Col sm={12} md={6} lg={4}>
              <select
                className="form-control"
                style={{ color: '#5d5d5d' }}
                onChange={(value) => {
                  setSelectLabel(value.target.value)
                }}
              >
                <option>Select...</option>
                {luckyNumber &&
                  luckyNumber.map((s, i) => (
                    <option key={i} value={s.title}>
                      {s.label}
                    </option>
                  ))}
              </select>
              {selectLabel !== 'Select...' && (
                <div style={{ marginTop: '12px', textAlign: 'center' }}>
                  {roundDate}-{selectLabel}
                </div>
              )}
            </Col>
            <Col sm={12} md={6} lg={3}>
              <input
                autoComplete="off"
                id="userId"
                style={{ color: '#5d5d5d' }}
                type="text"
                placeholder="userId"
                className="form-control mr-2"
                onChange={(e) => setUserId(e.target.value)}
                onKeyPress={(e) => {
                  if (e.key === 'Enter') {
                    addUserId()
                  }
                }}
              />
              {arrUserId &&
                arrUserId.map((value, i) => (
                  <div style={{ marginTop: '10px', textAlign: 'center' }} key={i}>
                    {value}
                    <Badge
                      className="ml-1"
                      variant="danger"
                      style={{ cursor: 'pointer' }}
                      onClick={() => {
                        setUserId(value)
                        removeUserId(value)
                      }}
                    >
                      x
                    </Badge>
                  </div>
                ))}
              <div style={{ marginTop: '10px', textAlign: 'center' }}>
                {files.map((data, i) => (
                  <div key={i} style={{ marginTop: '5px' }}>
                    {data}
                  </div>
                ))}
              </div>
            </Col>
            <Col>
              <input type="file" multiple style={{ marginTop: '11px' }} onChange={handleChange} />
            </Col>
          </Row>
          <div style={{ textAlign: 'center', marginTop: '20px' }}>
            <Button onClick={() => sendUserId()}>ส่งข้อมูล</Button>
          </div>
        </Card.Body>
      </Card>

      <Modal show={showRemoveModal} size="l">
        <Modal.Header>ยืนยัน</Modal.Header>
        <Modal.Body>ยืนยันการลบข้อมูล ?</Modal.Body>
        <Modal.Footer>
          <Button variant="danger light" onClick={() => setShowRemoveModal(false)}>
            ยกเลิก
          </Button>
          <Button variant="primary light" onClick={() => confirmRemove()}>
            ยืนยัน
          </Button>
        </Modal.Footer>
      </Modal>
      <Modal show={showEditModal} size="lg">
        <Modal.Header>
          <Modal.Title>แก้ไขข้อมูล</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Row className="my-1">
            <Col sm={3} className="mt-3">
              title :
            </Col>
            <Col sm={9}>
              <Form.Control
                type="text"
                placeholder="title"
                defaultValue={title ? title : selected.title}
                onChange={(e) => setTitle(e.target.value)}
              />
            </Col>
          </Row>
          <Row className="my-1">
            <Col sm={3} className="mt-3">
              label :
            </Col>
            <Col sm={9}>
              <Form.Control
                type="text"
                placeholder="label"
                defaultValue={label ? label : selected.label}
                onChange={(e) => setLabel(e.target.value)}
              />
            </Col>
          </Row>
          <Row className="my-1">
            <Col sm={3} className="mt-3">
              amount :
            </Col>
            <Col sm={9}>
              <Form.Control
                type="text"
                placeholder="amount"
                defaultValue={amount ? amount : selected.amount}
                onChange={(e) => setAmount(e.target.value)}
              />
            </Col>
          </Row>
          <Row className="my-1">
            <Col sm={3} className="mt-3">
              perClick :
            </Col>
            <Col sm={9}>
              <Form.Control
                type="text"
                placeholder="perClick"
                defaultValue={perClick ? perClick : selected.perClick}
                onChange={(e) => setPerClick(e.target.value)}
              />
            </Col>
          </Row>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="danger light" onClick={() => setShowEditModal(false)}>
            ยกเลิก
          </Button>
          {title === '' || label === '' || amount === '' || perClick === '' || parseInt(perClick) > parseInt(amount) ? (
            <Button disabled={true} variant="dark">
              ยืนยัน
            </Button>
          ) : (
            <Button variant="primary light" onClick={() => updateLuckyNumber()}>
              ยืนยัน
            </Button>
          )}
        </Modal.Footer>
      </Modal>
    </Fragment>
  )
}
export default LuckyNumber
